import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelText as _vModelText, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/info.png'
import _imports_1 from '@/assets/images/classroom-interaction/group/group-selected.png'
import _imports_2 from '@/assets/img/classroomInteraction/studentAttend/0.png'
import _imports_3 from '@/assets/img/classroomInteraction/studentAttend/1.png'
import _imports_4 from '@/assets/img/myCourseWare/courseWare/search.png'


_pushScopeId("data-v-0dcfbc25")
const _hoisted_1 = {
  key: 0,
  class: "container-mask",
  id: "container-mask"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "dv-rule" }, " 仅修改当前选中的分组方案的分数计分规则，不影响其他分组方案 ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "dv-rule-title" }, " 小组、学生单独计分 (适用于各组人数不同时) ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "dv-rule-info mt17" }, "示例:给全组+1分时，小组分数+1;", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "dv-rule-info" }, " 组内的学生分别+1给学生+1分时，小组分数不变 ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "dv-rule-title" }, " 小组分数为组内学生分数总和 (适用于各组人数相同时) ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "dv-rule-info mt17" }, " 示例:给全组+1分时，小组分数+ (1*组内人数) ; 组内的学生分别+1 ", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "dv-rule-info" }, "给组内某一个学生+1分时，小组分数+1", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "dv-btn-cancel-txt" }, "取 消", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "dv-btn-ok-txt" }, "确 定", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "dv-confirm-rule" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "dv-rule-confirm-title mt17" }, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "info-icon",
      src: _imports_0
    }),
    /*#__PURE__*/_createTextVNode(" 确认更改计分规则？ ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "dv-rule-confirm-info" }, " 更改小组计分规则，小组分数将会重新计算 ")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "dv-btn-cancel-txt" }, "取 消", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "dv-btn-ok-txt" }, "确 定", -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  class: "container",
  id: "sssid"
}
const _hoisted_19 = {
  key: 0,
  class: "container-popover"
}
const _hoisted_20 = { class: "selTime" }
const _hoisted_21 = { class: "dvTime" }
const _hoisted_22 = { class: "selType" }
const _hoisted_23 = {
  key: 0,
  class: "date-picker-wrapper",
  style: {"margin-left":"8px"}
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-date date-picker-icon" }, null, -1)
const _hoisted_25 = {
  key: 1,
  style: {"padding":"4px"}
}
const _hoisted_26 = {
  key: 2,
  class: "date-picker-wrapper"
}
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "el-icon-date date-picker-icon" }, null, -1)
const _hoisted_28 = {
  key: 0,
  class: "tab-container"
}
const _hoisted_29 = {
  key: 0,
  class: "tab-item-active-bar"
}
const _hoisted_30 = {
  key: 0,
  class: "tab-item-active-bar"
}
const _hoisted_31 = { class: "footer" }
const _hoisted_32 = {
  key: 0,
  class: "action-btn-div"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "common-icon icon" }, null, -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "多选", -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "common-icon icon" }, null, -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "随机", -1)
const _hoisted_38 = [
  _hoisted_36,
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "common-icon icon" }, null, -1)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "考勤", -1)
const _hoisted_41 = [
  _hoisted_39,
  _hoisted_40
]
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "common-icon icon" }, null, -1)
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "撤回上一步", -1)
const _hoisted_44 = [
  _hoisted_42,
  _hoisted_43
]
const _hoisted_45 = {
  key: 1,
  class: "multi-select-div"
}
const _hoisted_46 = { class: "relate" }
const _hoisted_47 = { class: "all-select" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("span", { class: "check-box-label" }, "全选", -1)
const _hoisted_49 = { class: "multi-select-div" }
const _hoisted_50 = {
  key: 2,
  class: "group"
}
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { class: "groupMenu" }
const _hoisted_53 = {
  key: 0,
  class: "white-box"
}
const _hoisted_54 = ["onClick"]
const _hoisted_55 = {
  key: 0,
  style: {"vertical-align":"middle"},
  src: _imports_1
}
const _hoisted_56 = {
  class: /*#__PURE__*/_normalizeClass({ active: true })
}
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "common-icon icon" }, null, -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("div", { class: "text" }, "分组", -1)
const _hoisted_59 = [
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = {
  key: 0,
  class: "all-unAttend"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("div", { class: "img-size" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    alt: ""
  })
], -1)
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "au-text" }, "全员缺勤", -1)
const _hoisted_63 = [
  _hoisted_61,
  _hoisted_62
]
const _hoisted_64 = {
  key: 1,
  class: "all-unAttend"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("div", { class: "img-size" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
const _hoisted_66 = /*#__PURE__*/_createElementVNode("div", { class: "au-text" }, "全员出勤", -1)
const _hoisted_67 = [
  _hoisted_65,
  _hoisted_66
]
const _hoisted_68 = { class: "order order-select" }
const _hoisted_69 = { class: "os-box" }
const _hoisted_70 = ["src"]
const _hoisted_71 = { class: "search-container" }
const _hoisted_72 = {
  key: 0,
  class: "search"
}
const _hoisted_73 = /*#__PURE__*/_createElementVNode("img", {
  class: "search-icon",
  src: _imports_4
}, null, -1)
_popScopeId()

import {
  ref,
  PropType,
  provide,
  computed,
  watch,
  readonly,
  shallowRef,
  VueElement,
} from "vue";
import { ElPopover, ElMessage } from "element-plus";
// 通知electron状态发生改变
import { cancelCommunication } from "@/electronService";
import BaseModal from "./components/base/BaseModal.vue";
import { eventCenter } from "@evideo/frontend-utils";
import store, { MutationNames } from "@/store";
import {
  getClassGroupPlans,
  getEvaluationNorms,
  getGroupPlanDetail,
  getStudentAttendanceRecords,
  getClassStudentEvaluationRecord,
  getLessonGroupEvaluateRecords,
  setGroupPlanScoreType,
  clearGroupEvaluateNormScore,
  setGroupEvaluateNormScoreByStudentSum,
  getStudentEvaluateRecordsByTime,
  addStudentEvaluateRecord,
} from "@/services/classroomInteraction";
import GroupEdit from "./components/group/edit.vue";
import Attendance from "./components/attendance/index.vue";
import AppraiseModal from "./components/base/AppraiseModal/AppraiseModal.vue";
import { ClassroomInterationNS } from "./types";
import logger from "@evideo/logger";
import Evaluation from "./components/evaluation/index.vue";
import { OrderValueEnum } from "./config";
import { handleSortGroupList, handleSortStudentList } from "./utils";
import pinyin from "pinyin";
import _ from "lodash";
import moment from "moment";
import { getCurrentActiveSemester } from "@/services/homework";

// 小组计分规则显示隐藏
type GetStoreInterface = (key: string) => any;
type SetStoreInterface = (key: string, value: any) => void;

type GetCurSubjectInterface = () => string;


export default _defineComponent({
  props: {
  visible: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
  getStore: {
    type: Function as PropType<GetStoreInterface>,
    default: undefined,
  },
  setStore: {
    type: Function as PropType<SetStoreInterface>,
    default: undefined,
  },
  getCurSubject: {
    type: Function as PropType<GetCurSubjectInterface>,
    default: undefined,
  },
},
  emits: ["update:visible"] as unknown as undefined,
  setup(__props, { expose, emit }: { emit: ({
  (event: "update:visible", newVisible: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props
const groupBox = ref(false);
// 小组二次确认显示隐藏
const confirmState = ref(false);
// 小组计分规则选项
// const scoreTypeRadio = ref((currentGroupInfo as any).value.score_type);
const scoreTypeRadio = ref(1);
// 是否全员出勤
const classAttend = ref(false);

// 调用子组件的切换出勤方法
const useChildAttend = ref<any>(null);

// 数据过滤类型
const dataType = ref<any>(0);
const disabledDate = (time: Date) => {
  return time.getTime() >= Date.now();
};
// 开始日期
const startDate = ref<any>("");
// 截止日期
const endDate = ref<any>("");
// 是否显示日期控件
const visibleDate = ref<any>(false);
// 是否显示撤回上一步
const visibleBack = ref<any>(false);

const modalStyle = ref({ height: "560px" });




// const visible = ref(props.visible);
const visible = computed(() => props.visible);

// 保存到全局存储
const setIntoStore = (key: string, value: any) => {
  if (props.setStore) {
    props.setStore(key, value);
  }
};

// 从全局获取数据
const getFromStore = (key: string): any => {
  if (props.getStore) {
    return props.getStore(key);
  }
  return undefined;
};

// 关闭弹窗
const handleCancel = () => {
  dataType.value = 0;
  startDate.value = "";
  endDate.value = "";
  visibleDate.value = false;
  emit("update:visible", false);
  cancelCommunication(false);
};
const createGroupVisible = ref(false);
const SubjectEnum = {
  MUSIC: "music",
  ART: "art",
};

const curSubject = ref<string>(SubjectEnum.MUSIC);

// todo 数据排序，provide传入排序方法
const order = ref(OrderValueEnum.FIRST_LETTER);
let orderStudent = ref(OrderValueEnum.FIRST_LETTER);
let orderGroup = ref(OrderValueEnum.FIRST_LETTER);
const orderOptions = [
  {
    icon: require("@/assets/images/classroom-interaction/order/letter.png"),
    value: OrderValueEnum.FIRST_LETTER,
    label: "按首字母",
  },
  {
    icon: require("@/assets/images/classroom-interaction/order/total.png"),
    value: OrderValueEnum.TOTAL_SCORE,
    label: "按总分最高",
  },
  {
    icon: require("@/assets/images/classroom-interaction/order/most.png"),
    value: OrderValueEnum.PRAISE_SCORE,
    label: "按表扬分数最高",
  },
  {
    icon: require("@/assets/images/classroom-interaction/order/least.png"),
    value: OrderValueEnum.TO_BE_IMPROV,
    label: "按待改进分数最高",
  },
];

const timeOptions = [
  {
    value: 0,
    label: "本节",
  },
  {
    value: 1,
    label: "本周",
  },
  {
    value: 2,
    label: "上周",
  },
  {
    value: 3,
    label: "本月",
  },
  {
    value: 4,
    label: "上月",
  },
  {
    value: 5,
    label: "本学期",
  },
  {
    value: 6,
    label: "全部",
  },
  {
    value: 7,
    label: "自定义",
  },
];

const isGroupMode = ref(false);
const multiSelectAction = ref(false);
const randomSelectAction = ref(false);
const attendanceAction = ref(false);
const attendanceDisabled = computed(() => isGroupMode.value);
const randomSelectDisabled = computed(() => attendanceAction.value);
const multiSelectDisabled = computed(() => attendanceAction.value);
const studentList = ref([]);
// 全班整体得分情况
const totalClassScore = ref([]);
const groupList = ref<any[]>([]);
// 班级id
const classId = computed(() => getFromStore("schoolClassId"));
// 是否登录
const isLogin = computed(() => getFromStore("isLogin"));
// 小组点评数据
const groupEvaluateData = ref([]);
// 分组计划id
const groupPlanId = computed({
  get: () => parseInt(getFromStore("groupPlanId")),
  set: (v) => {
    if (!v) {
      currentGroupInfo.value = null;
      groupEvaluateData.value = [];
    }
    setIntoStore("groupPlanId", v);
  },
});

// 小组详情
const currentGroupInfo = ref();
// 上课id
const lessonRecordId = computed(() => getFromStore("lessonRecordId"));
// 考勤数据
const attendanceData = ref([]);
const studentAttendanceData = ref<any[]>([]);
const schoolId = computed(() => getFromStore("schoolId"));
// 上课记录id
const lessonId = computed(() => getFromStore("lessonRecordId"));

// 评价模块列表入口ref
const evaluationListRef = ref();
const elSelectRef = ref();

const initPageState = () => {
  isGroupMode.value = false;
  order.value = OrderValueEnum.FIRST_LETTER;
  orderStudent.value = OrderValueEnum.FIRST_LETTER;
  orderGroup.value = OrderValueEnum.FIRST_LETTER;
  searchContent.value = "";
  searchSubmitContent.value = "";
};

// 学校变化时重新加载学校的评分指标
watch(
  () => [schoolId.value, isLogin.value],
  async (val) => {
    if (val[0] && val[1]) {
      await handleInitAppraiseInfo();
    }
  }
);

watch(
  () => [classId.value, lessonId.value],
  async (val) => {
    if (val[0] && val[1]) {
      initPageState();
      await getClassData();
    }
  },
  { immediate: true }
);
watch(
  () => lessonRecordId.value,
  async (val) => {
    if (val) {
      await getAttendanceData();
    }
  },
  { immediate: true }
);
watch(
  () => [studentList.value, attendanceData.value],
  (val) => {
    studentAttendanceData.value = studentList.value.map((i: any) => {
      const tmp: any = attendanceData.value.find(
        (j: any) => j.student_id === i.id
      );
      return { ...i, ...tmp };
    });
  },
  { immediate: true, deep: true }
);

// 切换时更新最新的数据
watch(
  () => visible.value,
  _.debounce((newValue: boolean, oldValue: boolean) => {
    if (newValue === true && oldValue === false) {
      getAttendanceData();
    }
  }, 300)
);
// 控制上一步显示隐藏
watch(
  () => store.state.evaluateRecord,
  (val) => {
    if (val === null) {
      visibleBack.value = false;
    } else {
      visibleBack.value = true;
    }
  },
  { immediate: true }
);
// 获取学生和分组数据
const getClassData = async (changeGroupPlanId = 0) => {
  if (!lessonId.value) {
    return;
  }
  if (changeGroupPlanId) {
    groupPlanId.value = changeGroupPlanId;
  }
  try {
    // const { data } = await getClassStudentEvaluationRecord(lessonId.value);
    const { data } = await getStudentEvaluateRecordsByTime({
      lesson_id: lessonId.value,
      start_time: startDate.value,
      end_time: endDate.value,
    });
    const { students = [], total_scores = [] } = data;
    totalClassScore.value = total_scores;
    // 拼音处理
    studentList.value = students.map((i: any) => ({
      ...i,
      py_name: pinyin(i.name, {
        style: pinyin.STYLE_NORMAL,
        mode: pinyin.MODE_SURNAME,
      }).join(""),
    }));
    const {
      data: { group_plans },
    } = await getClassGroupPlans(classId.value);
    groupList.value = group_plans;

    if (groupList.value.length === 0) {
      groupPlanId.value = 0;
    }
    if (
      groupList.value.length > 0 &&
      !groupList.value.map((i) => i.id).includes(groupPlanId.value)
    ) {
      groupPlanId.value = groupList.value[0].id;
    }

    console.log("学生和分组数据", data, group_plans);
  } catch (e) {
    logger.error("【课堂互动】获取学生和分组数据失败", e);
  }
};

const handleUpdateStudentList = async () => {
  if (!lessonId.value) {
    return;
  }
  try {
    // const { data } = await getClassStudentEvaluationRecord(lessonId.value);
    const { data } = await getStudentEvaluateRecordsByTime({
      lesson_id: lessonId.value,
      start_time: startDate.value,
      end_time: endDate.value,
    });
    const { students = [], total_scores = [] } = data;
    totalClassScore.value = total_scores;
    studentList.value = students.map((i: any) => ({
      ...i,
      py_name: pinyin(i.name, {
        style: pinyin.STYLE_NORMAL,
        mode: pinyin.MODE_SURNAME,
      }).join(""),
    }));
  } catch (e) {
    logger.error("【课堂互动】获取学生评分数据失败", e);
  }
};

const handleUpdateStudentAndGroupData = async () => {
  // const promiseList = [handleUpdateStudentList(), getGroupEvaluateData()];
  if (currentGroupInfo.value?.score_type === 2) {
    const params = {
      lesson_id: lessonId.value,
      group_plan_id: groupPlanId.value,
    };
    await setGroupEvaluateNormScoreByStudentSum(params);
    // promiseList.unshift(setGroupEvaluateNormScoreByStudentSum(params));
  }
  await handleUpdateStudentList();
  await getGroupEvaluateData();
  // return Promise.all(promiseList);
};

// 获取分组详情数据
const getGroupInfo = async () => {
  const {
    data: { group_plan_detail },
  } = await getGroupPlanDetail(groupPlanId.value);
  currentGroupInfo.value = group_plan_detail;
  scoreTypeRadio.value = currentGroupInfo.value.score_type;
  groupLenth.value = currentGroupInfo.value?.groups?.length || 0;
};
// 获取考勤数据
const getAttendanceData = async () => {
  const {
    data: { records },
  } = await getStudentAttendanceRecords(lessonRecordId.value);
  attendanceData.value = records;
};

// 搜索内容
const searchContent = ref("");
// 点击搜索时的内容
const searchSubmitContent = ref("");

/** 评价弹窗通用组件部分开始 */
// 评价弹窗
const appraiseModalInfo = ref<ClassroomInterationNS.AppraiseModalInfoType>({
  visible: false,
  msg: "",
  appraises: [],
  toBeImproves: [],
  autoClose: true,
});

// 显示评价弹窗
const handleShowAppraiseModal = (
  info: { msg: string },
  onOk?: ClassroomInterationNS.AppraiseModalOkFunc,
  onClose?: () => Promise<void>,
  autoClose?: boolean
) => {
  appraiseModalInfo.value.msg = info.msg;
  appraiseModalInfo.value.onCancel = onClose;
  appraiseModalInfo.value.onOk = onOk;
  appraiseModalInfo.value.autoClose = autoClose ?? true;
  appraiseModalInfo.value.visible = true;
};

// 评分弹窗关闭
const handleAppraiseModalClose = async () => {
  appraiseModalInfo.value.visible = false;
  if (appraiseModalInfo.value.onCancel) {
    await appraiseModalInfo.value.onCancel();
  }
};

// 选择了具体评分项目
const handleAppraiseModalSelect = async (value: any) => {
  if (appraiseModalInfo.value.onOk) {
    await appraiseModalInfo.value.onOk(value);
  }
  if (appraiseModalInfo.value.autoClose) {
    handleAppraiseModalClose();
  }
};

// 初始化评价弹窗的数据
const handleInitAppraiseInfo = async () => {
  try {
    const { data } = await getEvaluationNorms({ subject: curSubject.value });
    const { norms } = data;
    const appraises: any[] = [];
    const toBeImproves: any[] = [];
    console.log(norms);
    norms
      .filter((i: any) => i.subject === curSubject.value)
      .forEach((item: any) => {
        const data: any = {
          img: item.icon || "Concentration.png",
          title: item.name,
          norm_code: item.code,
          id: item.id,
          single_opr_score: item.single_opr_score,
        };
        // 类型是正面(1)还是负面(0)
        if (item.type === 1) {
          data.addPoint = Math.abs(parseInt(item.single_opr_score));
          appraises.push(data);
        } else {
          data.dockPoint = Math.abs(parseInt(item.single_opr_score));
          toBeImproves.push(data);
        }
      });
    appraiseModalInfo.value.appraises = appraises;
    appraiseModalInfo.value.toBeImproves = toBeImproves;
  } catch (err) {
    logger.error("获取评分指标失败", err);
  }
};

/** 评价弹窗通用组件部分结束 */

// 全员出勤组件切换
const changeClassAttend = () => {
  classAttend.value = !classAttend.value;
  let temp = classAttend.value;
  if (useChildAttend.value) {
    useChildAttend.value.changeAllAttend(temp);
  }
};
/** 排序搜索相关部分开始 **/
const sortListByOrderType: ClassroomInterationNS.SortListByOrderTypeFunc = (
  list: any[],
  type: number,
  isGroup: boolean
) => {
  if (isGroup === false) {
    const res = handleSortStudentList(list, type);
    return res;
  } else {
    const res = handleSortGroupList(list, type);
    return res;
  }
};

/** 排序搜索相关部分结束 **/

// 学生小组模式切换
const toggleMode = (isGroupModeNow = false) => {
  isGroupMode.value = isGroupModeNow;

  multiSelectAction.value = false;
  searchContent.value = "";
  // 学生列表在清空搜索框后需要重新刷新一下
  evaluationListRef.value.onSearch();
  searchSubmitContent.value = "";
  attendanceAction.value = false;
  // 小组学生切换的时候重置排序规则
  console.log(114, orderGroup.value, orderStudent.value);

  if (isGroupModeNow) {
    console.log(112, orderGroup.value);

    order.value = orderGroup.value;
  } else {
    console.log(113, orderStudent.value);

    order.value = orderStudent.value;
  }
  // elSelectRef.value.$forceUpdate();
};

const handleMultiSelect = () => {
  if (multiSelectDisabled.value) {
    return;
  }
  multiSelectAction.value = !multiSelectAction.value;
};
const handleRandomSelect = () => {
  // 考勤模式不允许随机
  if (attendanceAction.value) {
    return;
  }
  evaluationListRef.value.onRandom();
};
const closeRandomSelectAction = () => {
  randomSelectAction.value = false;
};
const handleBack = _.debounce(async () => {
  console.log("popopo", store.state.evaluateRecord);
  const params = store.state.evaluateRecord;
  console.log("popopo2", params);
  if (params !== null) {
    params.students.map((item: any) => {
      item.score = item.score * -1;
    });
    await addStudentEvaluateRecord(params);
    await handleUpdateStudentList();
    store.commit(MutationNames.CHANGE_EVALUATERECORD, null);
  } else {
    ElMessage.error({
      message: "暂无操作记录，无法进行「撤回上一步」",
    });
  }
  console.log("popopo1", params);
  //
}, 800);
const handleAttendance = () => {
  if (attendanceDisabled.value) {
    return;
  }
  attendanceAction.value = !attendanceAction.value;
  multiSelectAction.value = false;
  isGroupMode.value = false;
};
// 打开考勤
const handleOpenAttendance = () => {
  attendanceAction.value = true;
  multiSelectAction.value = false;
  isGroupMode.value = false;
};

const handleGroup = () => {
  console.log("分组");
};
// 小组计分规则取消按钮
const handleGroupBoxClose = () => {
  groupBox.value = false;
  scoreTypeRadio.value = currentGroupInfo.value.score_type;
};
// 小组计分规则确定按钮
const handleGroupBoxOk = () => {
  if (scoreTypeRadio.value === currentGroupInfo.value.score_type) {
    groupBox.value = false;
    confirmState.value = false;
    return;
  }
  // groupBox.value = false;
  confirmState.value = true;
};
// 小组计分二次确认取消按钮
const handleConfirmClose = () => {
  confirmState.value = false;
  scoreTypeRadio.value = currentGroupInfo.value.score_type;
};
const handleCloseModal = () => {
  scoreTypeRadio.value = currentGroupInfo.value.score_type;
};
// 小组计分二次确认确定按钮
const handleConfirmOk = async () => {
  try {
    await setGroupPlanScoreType({
      group_plan_id: groupPlanId.value,
      score_type: scoreTypeRadio.value,
    });
    const params = {
      lesson_id: lessonId.value,
      group_plan_id: groupPlanId.value,
    };
    if (scoreTypeRadio.value === 1) {
      await clearGroupEvaluateNormScore(params);
    } else {
      await setGroupEvaluateNormScoreByStudentSum(params);
    }
    await getGroupInfo();
    ElMessage.success("修改成功");
    handleUpdateStudentAndGroupData();
    groupBox.value = false;
    confirmState.value = false;
  } catch (e) {
    ElMessage.error({
      message: "请求发生错误",
    });
    console.error(e);
  }
};
const handleOrder = () => {
  // 是否小组模式
  if (!isGroupMode.value) {
    // 学生模式
    orderStudent.value = order.value;
  } else {
    // 小组模式
    orderGroup.value = order.value;
  }
  elSelectRef.value.$forceUpdate();
  console.log("排序");
};
const handleDate = async () => {
  console.log("startDate", startDate.value);
  console.log("endDate.value", endDate.value);
  let sd = "";
  let ed = "";
  if (startDate.value) {
    sd = moment(startDate.value).format("YYYY-MM-DD");
    console.log("a", sd);
  }
  if (endDate.value) {
    ed = moment(endDate.value).format("YYYY-MM-DD");
    console.log("b", ed);
  }

  if (sd && ed) {
    const isDay = moment(sd).isBefore(moment(ed), "day");
    console.log("days", isDay);
    if (isDay || sd == ed) {
      try {
        const { data } = await getStudentEvaluateRecordsByTime({
          lesson_id: lessonId.value,
          start_time: sd,
          end_time: ed,
        });
        const { students = [], total_scores = [] } = data;
        totalClassScore.value = total_scores;
        studentList.value = students.map((i: any) => ({
          ...i,
          py_name: pinyin(i.name, {
            style: pinyin.STYLE_NORMAL,
            mode: pinyin.MODE_SURNAME,
          }).join(""),
        }));
      } catch (e) {
        logger.error("【课堂互动】获取学生评分数据失败", e);
      }
    } else {
      ElMessage.info("结束日期需大于开始日期");
    }
  }
};
const handleType = async () => {
  if (dataType.value === 7) {
    // 自定义
    startDate.value = "";
    endDate.value = "";
    console.log("排序");
    visibleDate.value = true;
    return;
  } else if (dataType.value === 0) {
    // 本节课
    startDate.value = "";
    endDate.value = "";
    visibleDate.value = false;
  } else if (dataType.value === 1) {
    // 本周
    startDate.value = moment().startOf("week").format("YYYY-MM-DD");
    endDate.value = moment().endOf("week").format("YYYY-MM-DD");
    visibleDate.value = false;
  } else if (dataType.value === 2) {
    // 上周
    startDate.value = moment()
      .startOf("week")
      .subtract(7, "day")
      .format("YYYY-MM-DD");
    endDate.value = moment()
      .endOf("week")
      .subtract(7, "day")
      .format("YYYY-MM-DD");
    visibleDate.value = false;
  } else if (dataType.value === 3) {
    // 本月
    startDate.value = moment().startOf("month").format("YYYY-MM-DD");
    endDate.value = moment().endOf("month").format("YYYY-MM-DD");
    visibleDate.value = false;
  } else if (dataType.value === 4) {
    // 上月
    startDate.value = moment()
      .startOf("month")
      .subtract(1, "month")
      .format("YYYY-MM-DD");
    endDate.value = moment()
      .endOf("month")
      .subtract(1, "month")
      .format("YYYY-MM-DD");
    visibleDate.value = false;
  } else if (dataType.value === 5) {
    // 本学期
    await getCurrentActiveSemester().then((currentRes: any) => {
      console.log("currentRes", currentRes);
      startDate.value = currentRes.data.start_date;
      endDate.value = currentRes.data.end_date;
    });
    visibleDate.value = false;
  } else if (dataType.value === 6) {
    // 全部
    startDate.value = "";
    endDate.value = moment().format("YYYY-MM-DD");
    visibleDate.value = false;
  }
  try {
    const { data } = await getStudentEvaluateRecordsByTime({
      lesson_id: lessonId.value,
      start_time: startDate.value,
      end_time: endDate.value,
    });
    const { students = [], total_scores = [] } = data;
    totalClassScore.value = total_scores;
    studentList.value = students.map((i: any) => ({
      ...i,
      py_name: pinyin(i.name, {
        style: pinyin.STYLE_NORMAL,
        mode: pinyin.MODE_SURNAME,
      }).join(""),
    }));
  } catch (e) {
    logger.error("【课堂互动】获取学生评分数据失败", e);
  }
};
const handleSearch = () => {
  searchSubmitContent.value = searchContent.value;
  console.log("搜索");
  evaluationListRef.value.onSearch(searchContent.value);
  if (useChildAttend.value && useChildAttend.value.onSearch) {
    useChildAttend.value.onSearch(searchContent.value);
  }
};
const groupMenuVisible = ref(false);

const isCreateGroup = ref(true);
const handleCreateGroup = () => {
  groupMenuVisible.value = false;
  if (studentList.value.length < 3) {
    ElMessage.info("学生人数不足，无法分组");
    return;
  }
  isCreateGroup.value = true;
  createGroupVisible.value = true;
};
const handleEditGroup = () => {
  if (!groupList.value.length) {
    ElMessage.info("尚未分组，无法操作");
    return;
  }
  groupMenuVisible.value = false;
  isCreateGroup.value = false;
  createGroupVisible.value = true;
};
const setGroupRule = () => {
  if (!groupList.value.length) {
    ElMessage.info("尚未分组，无法操作");
    return;
  }
  groupMenuVisible.value = false;
  groupBox.value = true;
};

const selectGroup = (id: any) => {
  groupPlanId.value = id;
  setIntoStore("groupPlanId", id);
};

const getGroupEvaluateData = async () => {
  if (!lessonId.value || !groupPlanId.value) {
    return;
  }
  const {
    data: { groups },
  } = await getLessonGroupEvaluateRecords({
    lesson_id: lessonId.value,
    group_plan_id: groupPlanId.value,
  });
  groupEvaluateData.value = groups;
};
const isAllSelected = ref(false);
const changeIsAllSelected = (value: any) => {
  isAllSelected.value = value;
};
// 多选模式取消
const cancelMultiSelectAction = () => {
  evaluationListRef.value.onCancelMultiEvaluation();
};
// 考勤模式取消
const cancelAttendanceAction = () => {
  attendanceAction.value = false;
};
// 考勤保存按钮
const submitAllAttendance = () => {
  useChildAttend.value.submitAllAttendance();
};

const submitMultiSelect = () => {
  // multiSelectAction.value = false;
  evaluationListRef.value.onSubmitMultiSelect();
};
const selectAllBtn = () => {
  evaluationListRef.value.onSelectAllBtn();
};

watch(
  () => [groupPlanId.value, lessonId.value, isLogin.value],
  (val) => {
    if (val[2] && val[0]) {
      getGroupInfo();
      if (lessonId.value) {
        getGroupEvaluateData();
      }
    }
  },
  { immediate: true }
);

watch(
  () => visible.value,
  async (newVal) => {
    if (newVal === true && props.getCurSubject) {
      const subject = props.getCurSubject();
      if (subject) {
        console.log(subject);
        curSubject.value = subject;
        await handleInitAppraiseInfo();
      }
    }
  },
  { immediate: true }
);

eventCenter.sub("openAttendance", () => {
  handleOpenAttendance();
  emit("update:visible", true);
});

provide("setIntoStore", setIntoStore); // 全局存储方式
provide("getFromStore", getFromStore); // 全局获取数据
provide("groupPlanId", groupPlanId); // 分组计划id
provide("multiSelectAction", multiSelectAction); // 多选功能
provide("randomSelectAction", randomSelectAction); // 随机选择
provide("attendanceAction", attendanceAction); // 考勤选择
provide("orderStudent", orderStudent); // 当前学生排序
provide("orderGroup", orderGroup); // 当前小组排序
provide("searchContent", searchContent); // 搜索值
provide("searchSubmitContent", searchSubmitContent); // 点击搜索的值
provide("isGroupMode", isGroupMode); // 是否是小组模式
provide("toggleMode", toggleMode); // 学生/小组模式切换
provide("closeRandomSelectAction", closeRandomSelectAction); // 关闭随机选择功能
provide("groupList", groupList); // 分组信息
provide("studentList", studentList); // 所有学生信息
provide("totalClassScore", totalClassScore); // 全班得分信息
provide("createGroupVisible", createGroupVisible); // 显示快速分组
provide(
  "appraiseModalVisible",
  readonly(computed(() => appraiseModalInfo.value.visible))
); // 评价弹窗可见性
provide<ClassroomInterationNS.handleShowAppraiseModalProvider>(
  "handleShowAppraiseModal",
  handleShowAppraiseModal
); // 显示评价弹窗
provide("handleCloseAppraiseModal", handleAppraiseModalClose); // 关闭评价弹窗
provide("schoolClassId", classId); // 显示快速分组
provide("getClassData", getClassData); // 获取数据
provide("studentAttendanceData", studentAttendanceData); // 考勤数据
provide("getAttendanceData", getAttendanceData); // 更新考勤数据
provide("lessonId", lessonId); // 上课记录
provide("curSubject", curSubject); // 所属学科
provide("handleUpdateStudentList", handleUpdateStudentAndGroupData); // 更新学生信息列表
provide("currentGroupInfo", currentGroupInfo); // 具体分组详情
provide("groupEvaluateData", groupEvaluateData); // 小组详情
provide("handleUpdateStudentAndGroupData", handleUpdateStudentAndGroupData); // 更新学生和小组点评数据
provide("handleCreateGroup", handleCreateGroup); // 更新学生和小组点评数据
provide<ClassroomInterationNS.SortListByOrderTypeFunc>(
  "sortListByOrderType",
  sortListByOrderType
); // 全局排序功能
provide("attendanceData", attendanceData); // 考勤原始数据

const CIBodyRef: any = ref(null);
provide("CIBodyRef", CIBodyRef); // 打在body元素上，让组件挂载到body

// 获取小组数
let groupLenth = ref<number>(0);
const getGroupLenth = (len: number) => {
  groupLenth.value = len;
};
provide("groupLenth", getGroupLenth);
// 改变全选勾的状态
provide("changeIsAllSelected", changeIsAllSelected);
// 将节点挂载到body
const setBodyRef = () => CIBodyRef.value;

const customPrefix = shallowRef({
  render() {
    return "";
  },
});
expose({
  closeModal: handleCancel,
});

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_unref(visible))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(BaseModal, {
          visible: groupBox.value,
          "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => (groupBox.value = $event)),
          title: '小组计分规则：',
          bodyStyle: modalStyle.value,
          onOnClose: handleCloseModal,
          getContainer: setBodyRef
        }, {
          default: _withCtx(() => [
            _hoisted_2,
            _createElementVNode("div", null, [
              _createVNode(_component_el_radio_group, {
                modelValue: scoreTypeRadio.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (scoreTypeRadio.value = $event)),
                class: "ml-4 mf20",
                fill: "#bc7948"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_radio, {
                    label: 1,
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_3,
                      _hoisted_4,
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_radio, {
                    label: 2,
                    size: "large"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_6,
                      _hoisted_7,
                      _hoisted_8
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _createElementVNode("div", { class: "dv-btn" }, [
              _createElementVNode("div", {
                class: "dv-btn-cancel",
                onClick: handleGroupBoxClose
              }, _hoisted_10),
              _createElementVNode("div", {
                class: "dv-btn-ok",
                onClick: handleGroupBoxOk
              }, _hoisted_12)
            ])
          ]),
          _: 1
        }, 8, ["visible", "bodyStyle"]),
        _createVNode(BaseModal, {
          visible: confirmState.value,
          "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (confirmState.value = $event)),
          title: '小组计分规则：',
          showClose: false,
          bodyStyle: modalStyle.value,
          onOnClose: handleCloseModal,
          getContainer: setBodyRef
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _createElementVNode("div", { class: "dv-btn" }, [
              _createElementVNode("div", {
                class: "dv-btn-cancel",
                onClick: handleConfirmClose
              }, _hoisted_15),
              _createElementVNode("div", {
                class: "dv-btn-ok",
                onClick: handleConfirmOk
              }, _hoisted_17)
            ])
          ]),
          _: 1
        }, 8, ["visible", "bodyStyle"]),
        _createElementVNode("div", _hoisted_18, [
          (createGroupVisible.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createVNode(GroupEdit, {
                  isCreate: isCreateGroup.value,
                  groupPlanId: _unref(groupPlanId),
                  groupDetail: currentGroupInfo.value
                }, null, 8, ["isCreate", "groupPlanId", "groupDetail"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("h3", {
            class: "close",
            onClick: handleCancel
          }, [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_component_Close)
              ]),
              _: 1
            })
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_el_select, {
                  ref: elSelectRef,
                  onChange: handleType,
                  modelValue: dataType.value,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (dataType.value = $event)),
                  placeholder: "请选择",
                  "popper-append-to-body": false,
                  "popper-class": "select-popper"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(timeOptions, (item) => {
                      return _createVNode(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", null, _toDisplayString(item.label), 1)
                        ]),
                        _: 2
                      }, 1032, ["label", "value"])
                    }), 64))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (visibleDate.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createVNode(_component_el_date_picker, {
                      onChange: handleDate,
                      modelValue: startDate.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (startDate.value = $event)),
                      clearable: false,
                      type: "date",
                      placeholder: "开始日期",
                      class: "date-picker",
                      "prefix-icon": _unref(customPrefix),
                      "popper-class": "popper-picker",
                      "disabled-date": disabledDate
                    }, null, 8, ["modelValue", "prefix-icon"]),
                    _hoisted_24
                  ]))
                : _createCommentVNode("", true),
              (visibleDate.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, "—"))
                : _createCommentVNode("", true),
              (visibleDate.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                    _createVNode(_component_el_date_picker, {
                      onChange: handleDate,
                      modelValue: endDate.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (endDate.value = $event)),
                      clearable: false,
                      type: "date",
                      placeholder: "截止日期",
                      class: "date-picker",
                      "prefix-icon": _unref(customPrefix),
                      "popper-class": "popper-picker",
                      "disabled-date": disabledDate
                    }, null, 8, ["modelValue", "prefix-icon"]),
                    _hoisted_27
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 512), [
            [_vShow, !isGroupMode.value]
          ]),
          _createElementVNode("div", {
            class: "body",
            ref: CIBodyRef
          }, [
            _createVNode(AppraiseModal, {
              visible: appraiseModalInfo.value.visible,
              "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => (appraiseModalInfo.value.visible = $event)),
              "appraise-modal-info": { msg: appraiseModalInfo.value.msg },
              "to-be-improves": appraiseModalInfo.value.toBeImproves,
              appraises: appraiseModalInfo.value.appraises,
              onOnClose: handleAppraiseModalClose,
              onOnSelectAppraise: handleAppraiseModalSelect
            }, null, 8, ["visible", "appraise-modal-info", "to-be-improves", "appraises"]),
            (!attendanceAction.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _createElementVNode("div", {
                    class: _normalizeClass(!isGroupMode.value ? 'tab-item-active' : 'tab-item'),
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (toggleMode(false)))
                  }, [
                    _createElementVNode("div", null, "学生(" + _toDisplayString(studentList.value.length) + ")", 1),
                    (!isGroupMode.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(isGroupMode.value ? 'tab-item-active' : 'tab-item'),
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (toggleMode(true)))
                  }, [
                    _createElementVNode("div", null, "小组(" + _toDisplayString(_unref(groupLenth)) + ")", 1),
                    (isGroupMode.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_30))
                      : _createCommentVNode("", true)
                  ], 2)
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(Evaluation, {
              "is-group": isGroupMode.value,
              ref: evaluationListRef
            }, null, 8, ["is-group"]), [
              [_vShow, !attendanceAction.value]
            ]),
            _withDirectives(_createVNode(Attendance, {
              ref: useChildAttend,
              onCancelAttendanceAction: cancelAttendanceAction
            }, null, 512), [
              [_vShow, attendanceAction.value]
            ])
          ], 512),
          _createElementVNode("div", _hoisted_31, [
            (!multiSelectAction.value && !attendanceAction.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["multi-select", `${_unref(multiSelectDisabled) && 'gray'} ${
              multiSelectAction.value && 'multi-select-active'
            }`]),
                    onClick: handleMultiSelect
                  }, _hoisted_35, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["random-select", `${_unref(randomSelectDisabled) && 'gray'} ${
              randomSelectAction.value && 'random-select-active'
            }`]),
                    onClick: handleRandomSelect
                  }, _hoisted_38, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["attendance", `${_unref(attendanceDisabled) && 'gray'} ${
              attendanceAction.value && 'attendance-active'
            }`]),
                    onClick: handleAttendance
                  }, _hoisted_41, 2),
                  _withDirectives(_createElementVNode("div", {
                    class: "revoke",
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_unref(handleBack) && _unref(handleBack)(...args)))
                  }, _hoisted_44, 512), [
                    [_vShow, visibleBack.value]
                  ])
                ]))
              : _createCommentVNode("", true),
            (multiSelectAction.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["check-box", 
                    isAllSelected.value ? 'check-box-select' : 'check-box-no-select'
                  ])
                        }, null, 2),
                        _hoisted_48
                      ]),
                      _createElementVNode("div", {
                        onClick: selectAllBtn,
                        class: "checkbox-mask"
                      })
                    ])
                  ]),
                  _createElementVNode("div", { class: "flex-1 botton-center" }, [
                    _createElementVNode("div", {
                      class: "base-btn cancel",
                      onClick: cancelMultiSelectAction
                    }, " 取消 ")
                  ]),
                  _createElementVNode("div", { class: "flex-1 botton-center" }, [
                    _createElementVNode("div", {
                      class: "base-btn confirm",
                      onClick: submitMultiSelect
                    }, " 发送点评 ")
                  ])
                ]))
              : _createCommentVNode("", true),
            _withDirectives(_createElementVNode("div", _hoisted_49, [
              _createElementVNode("div", { class: "flex-1 botton-center" }, [
                _createElementVNode("div", {
                  class: "base-btn cancel",
                  onClick: cancelAttendanceAction
                }, " 取消 ")
              ]),
              _createElementVNode("div", { class: "flex-1 botton-center" }, [
                _createElementVNode("div", {
                  class: "base-btn confirm",
                  onClick: submitAllAttendance
                }, " 保存 ")
              ])
            ], 512), [
              [_vShow, attendanceAction.value]
            ]),
            (!multiSelectAction.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  (isGroupMode.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_51, [
                        _createVNode(_unref(ElPopover), {
                          visible: groupMenuVisible.value,
                          "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (groupMenuVisible.value = $event)),
                          "popper-class": "my-popover",
                          placement: "top",
                          trigger: "click",
                          teleported: false,
                          width: 295,
                          "show-arrow": false
                        }, {
                          reference: _withCtx(() => [
                            _createElementVNode("div", { onClick: handleGroup }, _hoisted_59)
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_52, [
                              (groupList.value.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groupList.value, (group) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: group.id,
                                        onClick: ($event: any) => (selectGroup(group.id))
                                      }, [
                                        _createTextVNode(_toDisplayString(group.name) + "-" + _toDisplayString(group.create_user_nickname) + "老师 ", 1),
                                        (_unref(groupPlanId) === group.id)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_55))
                                          : _createCommentVNode("", true)
                                      ], 8, _hoisted_54))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_56, " 已保存的分组(" + _toDisplayString(groupList.value.length) + "个) ", 1),
                              _createElementVNode("div", {
                                class: _normalizeClass({ active: false }),
                                onClick: handleEditGroup
                              }, " 微调学生分组 "),
                              _createElementVNode("div", {
                                class: _normalizeClass({ active: false }),
                                onClick: setGroupRule
                              }, " 修改当前小组记分规则 "),
                              _createElementVNode("div", {
                                class: _normalizeClass({ active: false }),
                                onClick: handleCreateGroup
                              }, " 快速分组 ")
                            ])
                          ]),
                          _: 1
                        }, 8, ["visible"])
                      ]))
                    : _createCommentVNode("", true),
                  (attendanceAction.value)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        onClick: changeClassAttend
                      }, [
                        (classAttend.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_60, _hoisted_63))
                          : _createCommentVNode("", true),
                        (!classAttend.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, _hoisted_67))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_68, [
              _withDirectives(_createVNode(_component_el_select, {
                ref: elSelectRef,
                onChange: handleOrder,
                modelValue: order.value,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (order.value = $event)),
                placeholder: "请选择排序方式",
                "popper-append-to-body": false,
                "popper-class": "select-popper"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(orderOptions, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_69, [
                          _createElementVNode("img", {
                            src: item.icon
                          }, null, 8, _hoisted_70),
                          _createElementVNode("span", null, _toDisplayString(item.label), 1)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"]), [
                [_vShow, !attendanceAction.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_71, [
              (!isGroupMode.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    _hoisted_73,
                    _withDirectives(_createElementVNode("input", {
                      type: "search",
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (searchContent.value = $event))
                    }, null, 512), [
                      [_vModelText, searchContent.value]
                    ]),
                    _createElementVNode("div", {
                      class: "search-btn",
                      onClick: handleSearch
                    }, "搜索")
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})